<template>
    <div class="pt-2 pb-6 md:py-6">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 class="text-2xl font-semibold text-gray-900">
                <slot name="title"></slot>
            </h1>
        </div>
        <div>
            <slot name="pre"></slot>
        </div>
        <div class="max-w-7xl mx-auto md:px-4 sm:px-6 md:px-8">
            <div class="bg-white overflow-hidden shadow sm:rounded-lg" scroll-region>
                <div class="px-4 py-5 sm:p-6">
                    <slot></slot>
                </div>
            </div>
            <!--            yield('after-panel')-->
            <div class="mt-5">
                <slot name="pagination"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
